import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentCartIsEmpty} from './currentCartIsEmpty';
import {
	PermissionName,
	currentUserHasAccess,
} from '@netx/core-permissions-next/enablers';

export const canDownloadCurrentCartMetadata = (): boolean => {
	if (currentCartIsEmpty()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return currentUserHasAccess(PermissionName.DOWNLOAD);
};
